import React from 'react';
import tw from 'tailwind-styled-components';
import "./HowTo.component.scss";
import { PageSubHeader } from '../pages/shared.styled';

const HeaderContainer = tw.section`bg-sky-200`;
const LeftBoxContainer = tw.div`grid grid-cols-4 gap-4`;
const LeftBox = tw.div`bg-secondary-lighter p-4 gap-4 h-[300px] flex-col shadow-lg flex`;
const BoxTitle = tw.div`font-bold text-xl text-primary`;

export default function HowTo() {
  return (
    <HeaderContainer>
      <section className='HowToSection'>
        <PageSubHeader>How to submit and browse products</PageSubHeader>

        <LeftBoxContainer>
          <LeftBox>
            <div>
              <BoxTitle>STEP 1</BoxTitle>
            </div>
            <div className='textbox flex-1'>
              Sign in to your ACR Repository account, or create an account using login.gov.
              Be sure to include your contact info as this will be used for your profile.
              <br />
              <br />
            </div>
            <div>
              <div className='mb-2'>
                <b className='caption-bold'>Applies to:</b>
              </div>
              <span className='l1 bg-accent-warm'>VENDORS</span>
              <span className='l2 bg-primary-vivid'>BUYERS</span>
            </div>
          </LeftBox>

          <LeftBox>
            <div>
              <BoxTitle>STEP 2</BoxTitle>
            </div>
            <div className='textbox flex-1'>
              Submit a request to your administration or  organization to join their Repo access.
              <br />
              <br />
            </div>
            <div>
              <div className='mb-2'>
                <b className='caption-bold'>Applies to:</b>
              </div>
              <span className='l1 bg-accent-warm'>VENDORS</span>
              <span className='l2 bg-primary-vivid'>BUYERS</span>
            </div>
          </LeftBox>

          <LeftBox>
            <div>
              <BoxTitle>STEP 3</BoxTitle>
            </div>
            <div className='textbox flex-1'>
              That’s it! Once approved, you’ll be able to access the full repository, where you can browse and review product ACRs.
              <br />
              <br />
            </div>
            <div>
              <div className='mb-2'>
                <b className='caption-bold'>Applies to:</b>
              </div>
              <span className='l1 bg-accent-warm'>VENDORS</span>
              <span className='l2 bg-primary-vivid'>BUYERS</span>
            </div>
          </LeftBox>

          <LeftBox>
            <div>
              <BoxTitle>STEP 4</BoxTitle>
            </div>
            <div className='textbox flex-1'>
              Users with Admin and Editor rights will be able to add and update product listing right from their dashboard.
              <br />
              <br />
            </div>

            <div>
              <div className='mb-2'>
                <b className='caption-bold'>Applies to:</b>
              </div>
              <span className='l1 bg-accent-warm'>VENDORS</span>
            </div>
          </LeftBox>
        </LeftBoxContainer>
      </section>
    </HeaderContainer >
  );
}


